<template>
  <div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="form"
                :model="form"
                :inline="true"
                style="padding: 10px"
              >
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_kh_like"
                    clearable
                    placeholder="款号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.sku"
                    placeholder="SKU"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_name_like"
                    clearable
                    placeholder="商品名称"
                  ></el-input>
                </el-form-item>

                <el-form-item class="_form-item">
                  <el-select
                    v-model="form.supply_id"
                    filterable
                    clearable
                    remote
                    :remote-method="fetchSupply"
                    placeholder="商家"
                  >
                    <el-option
                      v-for="item in options.supply"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    clearable
                    multiple
                    :multiple-limit="10"
                    placeholder="城市"
                  >
                    <el-option
                      v-for="item in options.supply_city"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select v-model="form.pgid" placeholder="代采组" clearable>
                    <el-option
                      v-for="item in options.pg_group"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    placeholder="代采员"
                    clearable
                  >
                    <el-option
                      v-for="item in options.pg_member"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-input
                    v-model="form.create_admin_like"
                    placeholder="操作人"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="件数:">
                  <el-col :span="11">
                    <YsInput
                      v-model="form.num_start"
                      pattern="positiveInt"
                      placeholder="起始件数"
                      clearable="true"
                    ></YsInput>
                  </el-col>
                  <el-col :span="2" class="link-line"> - </el-col>
                  <el-col :span="11">
                    <YsInput
                      v-model="form.num_end"
                      pattern="positiveInt"
                      placeholder="截止件数"
                      clearable="true"
                    ></YsInput
                  ></el-col>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button @click="handleReset">重置</el-button>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button type="primary" @click="handleSearch">
                    查询
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div style="display: inline-block; width: 60%">
            数据列表：共{{ resData.goods_no_num }}款，
            {{ resData.sum_num }} 件，金额￥{{ resData.sum_price }}
          </div>
          <div style="display: inline-block; text-align: right; width: 40%">
            <el-button size="mini" type="success" @click="handleBatchRecover">
              批量恢复不断货</el-button
            >
            <el-button size="mini" type="success" @click="handleExport">
              导出</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column align="center" prop="supply_name" label="商家">
              <template #default="{ row }">
                <div>
                  <span v-if="row.supply_name.length <= 4">{{
                    row.supply_name
                  }}</span>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="row.supply_name"
                    placement="top-start"
                  >
                    <div>{{ truncateText(row.supply_name, 4) }}</div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="planid">
              <div slot="header">
                <div>城市/</div>
                <div>代采组/</div>
                <div>代采员</div>
              </div>
              <template #default="{ row }">
                <div>{{ row.city }}</div>
                <div>
                  <span v-if="row.pgid_name.length <= 4">{{
                    row.pgid_name
                  }}</span>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="row.pgid_name"
                    placement="top-start"
                  >
                    <div>{{ truncateText(row.pgid_name, 4) }}</div>
                  </el-tooltip>
                </div>
                <div>{{ row.pg_member_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="goods_img" label="商品图片">
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.main_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="商品名称" prop="goods_name">
              <template #default="{ row }">
                <div>
                  <span v-if="row.goods_name.length <= 20">{{
                    row.goods_name
                  }}</span>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="row.goods_name"
                    placement="top-start"
                  >
                    <div>{{ truncateText(row.goods_name, 20) }}</div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="货号"
              prop="goods_no"
            ></el-table-column>
            <el-table-column
              align="center"
              label="款号"
              prop="goods_kh"
            ></el-table-column>
            <el-table-column align="center" prop="planid" label="SKU/颜色/尺码">
              <template #default="{ row }">
                {{ row.sku }} /{{ row.co_val }}/{{ row.si_val }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="plan_price"
              label="计划代采单价"
            >
            </el-table-column>

            <el-table-column align="center" prop="num" label="件数">
            </el-table-column>

            <el-table-column align="center" prop="total_price" label="总金额">
            </el-table-column>
            <el-table-column
              align="center"
              prop="reason"
              label="加入急救箱原因"
            >
            </el-table-column>
            <el-table-column align="center" prop="remark" label="备注">
            </el-table-column>
            <el-table-column align="center">
              <div slot="header">
                <div>操作来源/</div>
                <div>操作人/</div>
                <div>操作时间</div>
              </div>
              <template #default="{ row }">
                <div>{{ row.source_type }}</div>
                <div>{{ row.operator }}</div>
                <div>{{ row.create_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <div slot="header">
                <div>代采计划编号/</div>
                <div>生成方式/</div>
                <div>生成时间</div>
              </div>
              <template #default="{ row }">
                <div>{{ row.planid }}</div>
                <div>{{ row.ptype_str }}</div>
                <div>{{ row.plan_create_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template #default="{ row }">
                <el-button type="text" @click="handleRecover(row)"
                  >恢复不断货</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes"
            :total="resData.total"
            :page-size.sync="form.page_size"
            :page-sizes="[10, 20, 30, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="pageSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="恢复不断货"
      :visible.sync="recoverDialogVisible"
      width="30%"
      :before-close="handleRecoverDialogClose"
    >
      <el-table ref="recoverTable" :data="recoverlist" style="width: 100%">
        <el-table-column align="center" prop="num" label="急救箱">
          <template #default="scope">
            <el-button type="text" @click="toggleNum(scope.row)">{{
              scope.row.num
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="恢复不断货">
          <template #default="scope">
            <YsInput
              v-model="scope.row.recoverNum"
              pattern="digit"
              style="width: 80%"
              :clearable="false"
              :max="scope.row.initNum"
              @input="handleChangeRecoverNum(scope.row, 'input')"
            >
              <el-button
                slot="prepend"
                :disabled="scope.row.recoverNum <= 0"
                @click="handleChangeRecoverNum(scope.row, 'decrease')"
                >-</el-button
              >
              <el-button
                slot="append"
                :disabled="scope.row.recoverNum >= scope.row.initNum"
                @click="handleChangeRecoverNum(scope.row, 'increase')"
                >+</el-button
              >
            </YsInput>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleResetRecoverNum">重置</el-button>

        <el-button @click="handleSelectAll">全选</el-button>
        <el-button type="primary" @click="handleConfirmRecover"
          >确定恢复不断货</el-button
        >
      </div>
    </el-dialog>
    <BatchRecoverModal ref="batchRecoverModal" />
  </div>
</template>

<script>
import {
  getOptionsForEmergencyBoxList,
  postEmergencyBoxList,
  postCancelOutOfStock,
} from "@/openapi/erp/wcgPlanCancel.js";
import apiBaseURL from "@/utils/baseUrl.js";
import BatchRecoverModal from "@/pages/firstAidKit/components/BatchRecoverModal.vue";

export default {
  components: {
    BatchRecoverModal,
  },
  data() {
    return {
      resData: {
        total: 0,
        list: [],
      },
      tableLoading: false,
      form: {
        is_excel: 0,
        goods_no: "",
        goods_kh_like: "",
        sku: "",
        goods_name_like: "",
        supply_id: "",
        city_arr: [],
        pgid: "",
        pg_member_id: "",
        create_admin_like: "",
        num_start: "",
        num_end: "",
        page: 1,
        page_size: 10,
      },
      options: {
        supply: [],
        pg_group: [],
        pg_member: [],
        supply_city: [],
      },
      filterFold: false,
      curPage: 1,
      recoverlist: [{ num: 0, recoverNum: 0 }],
      recoverDialogVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    this.getOptions();
    this.fetchData(true);
  },
  methods: {
    // 获取搜索栏的下拉筛选项
    getOptions() {
      getOptionsForEmergencyBoxList()
        .then((res) => {
          this.options.pg_group = res.options_pg_group;
          this.options.pg_member = res.options_pg_member;
          this.options.supply_city = res.options_supply_city;
        })
        .catch((err) => {
          console.log("getOptionsForEmergencyBoxList err: ", err);
        });
    },
    fetchData(showLoading) {
      this.form.is_excel = showLoading ? 0 : 1;
      if (showLoading) {
        this.tableLoading = true;
      }
      postEmergencyBoxList(this.filteredForm)
        .then((res) => {
          if (showLoading) {
            this.resData = res;
            this.tableLoading = false;
          } else {
            window.open(apiBaseURL + res.file);
          }
        })
        .catch((err) => {
          console.log("postEmergencyBoxList err: ", err);
        });
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    // 切换页面条数
    pageSizeChange() {
      this.curPage = 1;
      this.handleCurrentChange(this.page);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 远程搜索商家
    fetchSupply(e) {
      this.$http
        .post("/erp/Common/fetchSupplyBySearch", { supply_name: e })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          }
          this.options.supply = res.data.data;
        });
    },
    handleBatchRecover() {
      this.$refs.batchRecoverModal.showModal();
    },
    handleReset() {
      this.form = this.$options.data().form;
      this.$refs.form.resetFields();
    },
    handleSearch() {
      this.form.page = 1;
      this.fetchData(true);
    },
    handleExport() {
      this.fetchData(false);
    },
    handleRecover(row) {
      const { num } = row;
      const _recoverlist = [
        {
          num,
          recoverNum: 0,
          planinfoid: row.planinfoid,
          initNum: Number(num),
        },
      ];
      this.$set(this, "recoverlist", _recoverlist);
      this.recoverDialogVisible = true;
    },
    handleConfirmRecover() {
      const params = {
        num: this.recoverlist[0].recoverNum,
        planinfoid: this.recoverlist[0].planinfoid,
      };
      postCancelOutOfStock(params)
        .then(() => {
          this.recoverDialogVisible = false;
          this.fetchData(true);
          this.$message.success("操作成功");
        })
        .catch((err) => {
          console.log("postCancelOutOfStock err: ", err);
        });
    },
    handleRecoverDialogClose() {
      this.recoverDialogVisible = false;
    },
    handleResetRecoverNum() {
      for (const item of this.recoverlist) {
        item.recoverNum = 0;
        item.num = item.initNum;
      }
    },
    handleChangeRecoverNum(row, action) {
      const _num = row.initNum;
      if (action === "input" && row.recoverNum >= _num) {
        row.num = 0;
        return;
      }
      if (action === "decrease" && row.recoverNum > 0) {
        row.recoverNum--;
      } else if (action === "increase" && row.recoverNum < _num) {
        row.recoverNum++;
      }
      if (row.recoverNum <= _num) {
        row.num = _num - row.recoverNum;
      }
    },
    handleSelectAll() {
      for (const item of this.recoverlist) {
        item.recoverNum = Number(item.num);
        item.num = 0;
      }
    },
    // 截断文本
    truncateText(text, maxLength) {
      if (typeof text !== "string") return "";
      return text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text;
    },
    toggleNum(row) {
      if (row.num > 0) {
        row.num = 0;
        row.recoverNum = row.initNum;
      } else {
        row.num = row.initNum;
        row.recoverNum = 0;
      }
    },
  },
};
</script>

<style scoped>
.link-line {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/firstAidKit/FirstAidKitList.vue